import { render, staticRenderFns } from "./PriceHistoryModal.vue?vue&type=template&id=6ab5602a"
import script from "./PriceHistoryModal.vue?vue&type=script&lang=js"
export * from "./PriceHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports